
import React, { useRef, useState } from "react";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import { getTrans as t } from "../../Localization/translations";
import ButtonLoading from '../../components/Loder/buttonLoading';
import { useForm } from "react-hook-form";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import ACHproviderService from "../../services/ACHproviders/ACHproviderServices";

const AddAchProvider = () => {
  const navigate = useNavigate();
  const checkBtn = useRef();
  const form = useRef();

  const { register, handleSubmit, formState: { errors }, setValue, trigger } = useForm();
  // const [ACH_name, setACH_name] = useState("");

  const [achprovider, setAchprovider] = useState({
    immediate_destination: "",
    immediate_destination_name: "",
    immediate_origin: "",
    immediate_origin_name: "",
    company_identification: "",
    standard_entry_class_code: "",
    originating_bank_fid: "",
    originator_tax_id: "",
    ach_operator_name: "",
    destination: "",
    destination_name: "",
    service_class_code: "",
  });

  const [disable, setDisable] = useState(false);
  const [loading, setLoading] = useState(false);

  // Change handler
  const achChange = (e) => {
    const { name, value } = e.target;
    setAchprovider((prev) => ({
      ...prev,
      [name]: value,
    }));
    setValue(name, value, { shouldValidate: true });
    trigger(name);
  };

  // Cancel handler
  const handelClick = () => {
    navigate("/achproviders");
  };

  // Submit handler
  const handleRegister = () => {
    setLoading(true);
    setDisable(true);

    ACHproviderService.addachprovider(achprovider)
      .then((response) => {
        if(response.data.success === 1){

          toast.success("ACH Provider added successfully", {
            position: "top-right",
            autoClose: 1000,
          });
          navigate("/achproviders");
        }
        else{
          toast.error(response.data.error)

        }
      })
      .catch(() => {
        toast.error("Failed to add ACH Provider");
      })
      .finally(() => {
        setLoading(false);
        setDisable(false);
      });

  };


  const renderInput = ({
    name,
    label,
    tooltip,
  }) => (
    <div className="col-sm-6">
      <label className="col-form-label required">
        {t(label)}&nbsp;
        <Tooltip content={t(tooltip)}>
          <i className="fa fa-light fa-circle-info"></i>
        </Tooltip>
      </label>
      <input
        value={achprovider[name]}
        className={`form-control${errors[name] ? " is-invalid" : ""}`}
        type="text"
        name={name}
        id={name}
        {...register(name, {
          required: true,
          onChange: achChange,
        })}
      />
      <div className="invalid-feedback" style={{ display: errors[name] ? "block" : "none" }}>
        {errors[name]?.type === "required" && `${t(label)} is required`}
      </div>
    </div>
  );

  return (
    <div className="page-wrapper">
      <ToastContainer />
      <div className="content container-fluid">
        <div className="header pb-0 mb-3 pt-3">
          <h5>{t("Create New ACH Provider")}</h5>
          <h6>
            <Link to="/achproviders" className="tc">
              {t("ACH Providers")}
            </Link>{" "}
            /  <span>{t("New ACH Provider")}</span>
          </h6>

          <div className="show_invoice">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <Form
                      role="form text-left"
                      onSubmit={handleSubmit(handleRegister)}
                      ref={form}
                      action="."
                      method="POST"
                    >

                      <>
                        <div className="row">
                          <div className="">
                            <div className="col-lg-12">

                              <div className="form-group row">
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Immediate Destination")}&nbsp;
                                    <Tooltip content={t("immediate_destination_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.immediate_destination}
                                    className={`form-control${errors.immediate_destination ? " is-invalid" : ""}`}
                                    type="text"
                                    name="immediate_destination"
                                    id="immediate_destination"
                                    {...register("immediate_destination", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.immediate_destination ? "block" : "none" }}>
                                    {errors.immediate_destination?.type === "required" && "Immediate Destination is required"}
                                  </div>
                                </div>
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Immediate Destination Name")}&nbsp;
                                    <Tooltip content={t("Immediatedestname_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.immediate_destination_name}
                                    className={`form-control${errors.immediate_destination_name ? " is-invalid" : ""}`}
                                    type="text"
                                    name="immediate_destination_name"
                                    id="immediate_destination_name"
                                    {...register("immediate_destination_name", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.immediate_destination_name ? "block" : "none" }}>
                                    {errors.immediate_destination_name?.type === "required" && "Immediate Destination Name is required"}
                                  </div>
                                </div>
                              </div>
                              <div className="form-group row">
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Immediate Origin")}&nbsp;
                                    <Tooltip content={t("immediate_origin_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.immediate_origin}
                                    className={`form-control${errors.immediate_origin ? " is-invalid" : ""}`}
                                    type="text"
                                    name="immediate_origin"
                                    id="immediate_origin"
                                    {...register("immediate_origin", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.immediate_origin ? "block" : "none" }}>
                                    {errors.immediate_origin?.type === "required" && "Immediate Origin is required"}
                                  </div>
                                </div>
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Immediate Origin Name")}&nbsp;
                                    <Tooltip content={t("immediate_origin_name_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.immediate_origin_name}
                                    className={`form-control${errors.immediate_origin_name ? " is-invalid" : ""}`}
                                    type="text"
                                    name="immediate_origin_name"
                                    id="immediate_origin_name"
                                    {...register("immediate_origin_name", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.immediate_origin_name ? "block" : "none" }}>
                                    {errors.immediate_origin_name?.type === "required" && "Immediate Origin Name is required"}
                                  </div>
                                </div>
                              </div>
                              <div className="form-group row">
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Company Identification")}&nbsp;
                                    <Tooltip content={t("CompanyIdentification_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.company_identification}
                                    className={`form-control${errors.company_identification ? " is-invalid" : ""}`}
                                    type="text"
                                    name="company_identification"
                                    id="company_identification"
                                    {...register("company_identification", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.company_identification ? "block" : "none" }}>
                                    {errors.company_identification?.type === "required" && "Company Identification is required"}
                                  </div>
                                </div>
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Standard Entry Class Code")}&nbsp;
                                    <Tooltip content={t("StandardEntryClassCode_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.standard_entry_class_code}
                                    className={`form-control${errors.standard_entry_class_code ? " is-invalid" : ""}`}
                                    type="text"
                                    name="standard_entry_class_code"
                                    id="standard_entry_class_code"
                                    {...register("standard_entry_class_code", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.standard_entry_class_code ? "block" : "none" }}>
                                    {errors.standard_entry_class_code?.type === "required" && "Standard Entry Class Code is required"}
                                  </div>
                                </div>
                              </div>
                              <div className="form-group row">
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Originating BANK FID")}&nbsp;
                                    <Tooltip content={t("OriginatingBankFID_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.originating_bank_fid}
                                    className={`form-control${errors.originating_bank_fid ? " is-invalid" : ""}`}
                                    type="text"
                                    name="originating_bank_fid"
                                    id="originating_bank_fid"
                                    {...register("originating_bank_fid", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.originating_bank_fid ? "block" : "none" }}>
                                    {errors.originating_bank_fid?.type === "required" && "Originating BANK FID is required"}
                                  </div>
                                </div>
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Originator Tax ID")}&nbsp;
                                    <Tooltip content={t("OriginatorTaxID_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.originator_tax_id}
                                    className={`form-control${errors.originator_tax_id ? " is-invalid" : ""}`}
                                    type="text"
                                    name="originator_tax_id"
                                    id="originator_tax_id"
                                    {...register("originator_tax_id", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.originator_tax_id ? "block" : "none" }}>
                                    {errors.originator_tax_id?.type === "required" && "Originator Tax ID is required"}
                                  </div>
                                </div>
                              </div>
                              <div className="form-group row">
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("ACH Operator Name")}&nbsp;
                                    <Tooltip content={t("ACHOperatorname_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.ach_operator_name}
                                    className={`form-control${errors.ach_operator_name ? " is-invalid" : ""}`}
                                    type="text"
                                    name="ach_operator_name"
                                    id="ach_operator_name"
                                    {...register("ach_operator_name", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.ach_operator_name ? "block" : "none" }}>
                                    {errors.ach_operator_name?.type === "required" && "ACH Operator Name is required"}
                                  </div>
                                </div>
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Destination")}&nbsp;
                                    <Tooltip content={t("Destination_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.destination}
                                    className={`form-control${errors.destination ? " is-invalid" : ""}`}
                                    type="text"
                                    name="destination"
                                    id="destination"
                                    {...register("destination", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.destination ? "block" : "none" }}>
                                    {errors.destination?.type === "required" && "Destination is required"}
                                  </div>
                                </div>
                              </div>
                              <div className="form-group row">
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Destination Name")}&nbsp;
                                    <Tooltip content={t("DestinationName_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.destination_name}
                                    className={`form-control${errors.destination_name ? " is-invalid" : ""}`}
                                    type="text"
                                    name="destination_name"
                                    id="destination_name"
                                    {...register("destination_name", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.destination_name ? "block" : "none" }}>
                                    {errors.destination_name?.type === "required" && "Destination Name is required"}
                                  </div>
                                </div>
                                <div className="col-sm-6">
                                  <label className="col-form-label required">
                                    {t("Service Class Code")}&nbsp;
                                    <Tooltip content={t("ServiceClassCode_Tooltip")}>
                                      <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                  </label>
                                  <input
                                    value={achprovider.service_class_code}
                                    className={`form-control${errors.service_class_code ? " is-invalid" : ""}`}
                                    type="text"
                                    name="service_class_code"
                                    id="service_class_code"
                                    {...register("service_class_code", {
                                      required: true,
                                      onChange: achChange,
                                    })}
                                  />
                                  <div className="invalid-feedback" style={{ display: errors.service_class_code ? "block" : "none" }}>
                                    {errors.service_class_code?.type === "required" && "Service Class Code is required"}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="text-left py-3">
                          <button
                            type="button"
                            onClick={handelClick}
                            className="btn-cancel-invoice border-0 btn btn-secondary btn-gradient-primary btn-md"
                            disabled={disable}
                          >
                            {t("Cancel")}
                          </button>
                          &nbsp;&nbsp;
                          <button
                            type="submit"
                            className="btn-continue border-0 btn btn-primary btn-gradient-primary btn-md"
                            disabled={disable}
                          >
                            {loading === false ? t("Save") : <ButtonLoading />}
                          </button>
                          &nbsp;&nbsp;
                        </div>
                      </>

                      <CheckButton
                        style={{ display: "none" }}
                        ref={checkBtn}
                      />
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddAchProvider;